/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de négociation :\n- BUYER : Acquéreur\n- SELLER : Vendeur\n
 */
export const propertyNegotiationTypeSchema = z.enum(["BUYER", "SELLER"]).default("BUYER").describe("Type de négociation :\n- BUYER : Acquéreur\n- SELLER : Vendeur\n")